import type { ItemStoreState } from "@editor/items/ItemStore";
import type { Migration } from "./Migration";
import type { SetOptional } from "type-fest";

const migration: Migration = {
  applyToVersions: "<2.9.0",
  type: "before",
  name: "remove different curvePoints",
  migrate: (data: { relations?: ItemStoreState<OldRelationItem | NewRelationItem>, elementMomentums?: ItemStoreState<OldMomentumItem | NewMomentumItem> }) => {
    const relationStoreState = data?.relations;
    if (relationStoreState) {
      const allRelations = relationStoreState.items;

      // transfer "changeCurvePoints" and "changeCurveType" to "curvePoints" and "curveType"
      for (const relation of Object.values(allRelations)) {
        if ("changeCurvePoints" in relation) {
          const transferProperties: SetOptional<OldRelationItem, "changeCurvePoints" | "changeCurveType"> = { ...relation };
          delete transferProperties.changeCurvePoints;
          delete transferProperties.changeCurveType;

          const newRelation: NewRelationItem = {
            ...transferProperties,
            curvePoints: relation.changeCurvePoints,
            curveType: relation.changeCurveType
          };

          relationStoreState.items[relation.id] = newRelation;
        }
      }
    }

    const elementMomentumStoreState = data?.elementMomentums;
    if (elementMomentumStoreState) {
      const allElementMomentums = elementMomentumStoreState.items;

      // transfer "constantCurvePoints" and "constantCurveType" to "curvePoints" and "curveType"
      for (const elementMomentum of Object.values(allElementMomentums)) {
        if ("constantCurvePoints" in elementMomentum) {
          const transferProperties: SetOptional<OldMomentumItem, "constantCurvePoints" | "constantCurveType"> = { ...elementMomentum };
          delete transferProperties.constantCurvePoints;
          delete transferProperties.constantCurveType;

          const newElementMomentum: NewMomentumItem = {
            ...transferProperties,
            curvePoints: elementMomentum.constantCurvePoints,
            curveType: elementMomentum.constantCurveType
          };

          elementMomentumStoreState.items[elementMomentum.id] = newElementMomentum;
        }
      }
    }

    return data;
  }
};

type OldMomentumItem = {
  type: "momentum";
  id: number;
  uid: string;
  createdAt: number;

  constantCurveType: string;
  constantCurvePoints: { x: number, y: number }[];
};

type NewMomentumItem = {
  type: "momentum";
  id: number;
  uid: string;
  createdAt: number;

  curvePoints: { x: number, y: number }[];
  curveType: string;
};

type OldRelationItem = {
  type: "relation";
  id: number;
  uid: string;
  createdAt: number;

  changeCurveType: string;
  changeCurvePoints: { x: number, y: number }[];
};

type NewRelationItem = {
  type: "relation";
  id: number;
  uid: string;
  createdAt: number;

  curvePoints: { x: number, y: number }[];
  curveType: string;
};

export default migration;